<template>
  <div class="reports-view">
    <top-bar
      title="Reportes"
    />
    <scrollable-container>
      <el-container class="el-card">
        <el-form>
          <el-row
            :gutter="20"
          >
            <el-col
              :lg="8"
            >
              <el-form-item label="Periodo">
                <el-select v-model="period">
                  <el-option
                    v-for="item in periods"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              :lg="8"
            >
              <el-form-item label="Tipo">
                <el-select v-model="type">
                  <el-option
                    v-for="item in reportTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              :lg="8"
            >
              <el-form-item
                label="Áreas"
              >
                <el-switch
                  active-text="Incluir áreas"
                  v-model="withDivisions"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-button
                type="primary"
                @click="download"
              >
                Descargar
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-container>
    </scrollable-container>
  </div>
</template>

<script>
import TopBar from '@/components/top-bar'
import ScrollableContainer from '@/components/scrollable-container'
import DefaultGuards from '@/guards/default.guards'

/**
 * 'Reports.view' Component
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */
export default {
  name: 'ReportsView',
  components: { ScrollableContainer, TopBar },
  data () {
    return {
      type: null,
      period: null,
      withDivisions: false,
      reportTypes: [
        {
          label: 'Por distribuidor',
          value: 'dealer'
        },
        {
          label: 'Por sucursal',
          value: 'branch'
        },
        {
          label: 'Por evaluación',
          value: 'evaluations'
        }
      ]
    }
  },
  computed: {
    periods () {
      return this.$store.getters['periods/items']
    }
  },
  methods: {
    download () {
      if (!this.type) {
        this.$notify('Debe de seleccionar un tipo de reporte')
        return
      }

      let link = process.env.API_URL + 'report/' + this.type
      if (this.withDivisions && this.type !== 'evaluations') {
        link += '/divisions'
      }
      if (this.period) {
        link += '?period=' + this.period
      }
      document.location = link
    }
  },
  beforeRouteEnter: DefaultGuards.onQuery('periods', { limit: 100 })
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
.reports-view {
  .el-card {
    padding: 20px 40px;
    margin: 20px;
    background-color: white;
  }
}

.el-form-item__label {
  display: block;
  width: 100%;
  float: none;
}
</style>



// WEBPACK FOOTER //
// src/views/app/reports/reports.view.vue